import { DataFilter } from './interface';
import { BoolEquals, StringEquals } from '@vendasta/automata';
import {
  BoolDisplayService,
  BoolOptionsComponent,
  FreeTextInputComponent,
  FreeTextDisplayService,
} from './dynamic-options';

const IS_REVIEW_REQUEST_ENABLED = '{.is_review_request_enabled}';
const CONNECTION_STATUS = '{.connection_status}';
export class IsReviewRequestEnabled implements DataFilter {
  rules = [new BoolEquals(IS_REVIEW_REQUEST_ENABLED)];
  dataEntryComponent = BoolOptionsComponent;
  displayService = BoolDisplayService;
  label = 'AUTOMATIONS.EDITOR.FILTERS.INTEGRATIONS.DATA_LABELS.REVIEW_REQUEST_ENABLED';
  comparisonLabels = ['AUTOMATIONS.EDITOR.FILTERS.INTEGRATIONS.COMPARISON.IS'];
}

export class ConnectionStatus implements DataFilter {
  rules = [new StringEquals(CONNECTION_STATUS)];
  dataEntryComponent = FreeTextInputComponent;
  displayService = FreeTextDisplayService;
  label = 'AUTOMATIONS.EDITOR.FILTERS.INTEGRATIONS.DATA_LABELS.CONNECTION_STATUS';
  comparisonLabels = ['AUTOMATIONS.EDITOR.FILTERS.INTEGRATIONS.COMPARISON.IS'];
}
export const CONNECTION_DETAILS_COMPONENTS: Map<string, DataFilter> = new Map<string, DataFilter>([
  [IS_REVIEW_REQUEST_ENABLED, new IsReviewRequestEnabled()],
  [CONNECTION_STATUS, new ConnectionStatus()],
]);
